import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { Auth0Provider } from './providers/Auth0Provider';
import Layout from './components/Layout';
import { firebaseConfig } from './config';
import { queryClient } from './config/queryClient';
import ThemeProviders from './providers/ThemeProviders';
import { store } from './redux/store';
import './styles/main.css';
import { getUrlParam, isDevelopment, isElectron, setLocalStorage } from './utils';
import FirebaseProvider from './utils/firebase/FirebaseProvider';
import initilizeSentry from './utils/sentry';

let DesktopTitleBar = () => <></>;
// BrowserRouter is meant for request-based environments
let Router = BrowserRouter;

// HashRouter is meant for file-based environments
if (isElectron()) {
  Router = HashRouter;
  DesktopTitleBar = require('./components/DesktopTitleBar').default;
}

if (!isDevelopment()) {
  initilizeSentry();
}

const toastOptions = {
  duration: 2000,
  success: {
    duration: 2000
  },
  error: {
    duration: Infinity
  }
};

const App = () => {
  useEffect(() => {
    const appId = getUrlParam('app_id');

    // IMPORTANT: Admin UI uses `app` key to track workspace instead of `appId`
    if (appId) {
      setLocalStorage({ appId });
    }
  }, []);

  return (
    <>
      {isElectron() && <DesktopTitleBar />}
      <Provider store={store}>
        <Router>
          <Auth0Provider>
            <FirebaseProvider config={firebaseConfig}>
              <ThemeProviders>
                <QueryClientProvider client={queryClient}>
                  <Toaster
                    position="top-center"
                    containerClassName="toast-container"
                    toastOptions={toastOptions}
                  />
                  <Layout />
                </QueryClientProvider>
              </ThemeProviders>
            </FirebaseProvider>
          </Auth0Provider>
        </Router>
      </Provider>
    </>
  );
};

const root = document.getElementById('root');
const container = createRoot(root);

container.render(<App />);
